import api from '@/apis/BaseApi';
import vm from '@/main';
import { quizModel} from "@/models/WorkspaceModel";

export default class AnswerGroupApi {
    static async getQuizGroupById(uuid:string): Promise<string> {
        const result = await api.get('/answer-group/preview/' + uuid);
        return result.data;
    }
}